module.exports = __webpack_public_path__ + "img/void-chart-filters.e8dd1b7d.gif";